"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WinLoseRatio = void 0;
/**
 * @internal
 * Describes the win/lose ratio
 */
var WinLoseRatio = /** @class */ (function () {
    /**
     * @param won The amount of wins
     * @param lost The amount of loses
     */
    function WinLoseRatio(won, lost) {
        this.won = won;
        this.lost = lost;
    }
    Object.defineProperty(WinLoseRatio.prototype, "ratio", {
        /**
         * Calculates the ratio of won and lost games.
         */
        get: function () {
            return this.won / this.lost;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WinLoseRatio, "Zero", {
        /**
         * Helper property that returns an empty WinLoseRatio.
         */
        get: function () {
            return new WinLoseRatio(0, 0);
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Sums the WinLoseRatio
     * @param ratios The ratios that needs to be added together
     * @returns A new WinLoseRatio
     */
    WinLoseRatio.sum = function () {
        var ratios = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            ratios[_i] = arguments[_i];
        }
        var won = ratios.reduce(function (pv, cv) { return pv + cv.won; }, 0);
        var lost = ratios.reduce(function (pv, cv) { return pv + cv.lost; }, 0);
        return new WinLoseRatio(won, lost);
    };
    return WinLoseRatio;
}());
exports.WinLoseRatio = WinLoseRatio;
